import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var DumpsterFire = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94l25.6-128H49.7zM272 160V32h-98.9l-25.6 128H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1 1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304v128zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2-.1-.7-.3-1.4-.5-2.1l-25.9-84.1c-3.1-10-12.4-16.9-22.9-16.9h-90.8l12.8 64.2c9.6 1 19 4.9 26.6 11.8 11.7 10.6 23 21.6 33.9 33.1 1.6-1.6 3.3-3.2 5-4.8zm-188.7 74.4c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32h-4c-17.7 0-32 14.3-32 32s14.3 32 32 32h12l20 160c0 17.7 14.3 32 32 32s32-14.3 32-32h209.6c-31-34.7-49.6-80.6-49.6-129.9 0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 87.8 70.3 159.9 160 159.9 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
  }));
});
DumpsterFire.displayName = 'DumpsterFire';
export var DumpsterFireDimensions = {
  height: 512,
  width: 640
};